<template>
  <div>
    <section class="customer-voice-manager-create ly-create">
      <div class="section-inner">
        <div class="section-cont">
          <h2>고객의 소리 담당자 관리</h2>
          <p class="site-path">
            <span>Home</span>&nbsp;&gt;&nbsp;
            <span>SUPPORT</span>&nbsp;&gt;&nbsp;
            <span>고객의 소리 담당자 관리</span>
          </p>
          <!-- /.site-path -->
          <table>
            <colgroup>
              <col class="col1" />
              <col class="col2" />
            </colgroup>
            <tr>
              <th scope="row">
                <label for="customer-voice-manager-name">담당자</label>
              </th>
              <td>
                <input
                  type="text"
                  id="customer-voice-manager-name"
                  name="customer-voice-manager-name"
                  autofocus
                  v-model="name"
                />
              </td>
            </tr>
            <tr>
              <th scope="row">
                <label for="customer-voice-manager-num">연락처</label>
              </th>
              <td>
                <input
                  type="text"
                  id="customer-voice-manager-num"
                  name="customer-voice-manager-num"
                  v-model="mobile_no"
                />
              </td>
            </tr>
            <tr>
              <th scope="row">
                <label for="customer-voice-manager-email">이메일</label>
              </th>
              <td>
                <input
                  type="text"
                  id="customer-voice-manager-email"
                  name="customer-voice-manager-email"
                  v-model="email"
                />
              </td>
            </tr>
          </table>
          <!-- /.table-->
          <router-link
            :to="{ name: 'CustomerVoiceManagerList' }"
            class="btn-white"
            >목록</router-link
          >
          <button class="btn-blue btn-right" @click="onClickCreate">저장</button>
          <!-- /.btn -->
        </div>

        <app-footer />
      </div>
    </section>
  </div>
</template>

<script>
import AppFooter from "../../AppFooter.vue";
import mananger_handle_mixin from '../../../mixins/managerHandle_mixin'; 

export default {
  components: { AppFooter },
  name: "CustomerVoiceManagerCreate",
  mixins: [mananger_handle_mixin],
  data() {
    return {
      taskpart: 'customervoice',
    };
  },
  methods: {
    onClickCreate() {
      if( this.name == null  || this.name === undefined || this.name.length <= 0 ) return ;  
      if( this.mobile_no == null || this.mobile_no === undefined || this.mobile_no.length <= 0 ) return ; 
      if( this.email == null  || this.email === undefined || this.email.length <= 0 ) return ; 

      this.reqCreateManager( {
          taskpart: this.taskpart,
          name: this.name,
          mobile_no: this.mobile_no,
          email: this.email ,
        } , "CustomerVoiceManagerList" ) ; 
    },
  },
};
</script>
